import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useCart } from '../../context/CartContext';

export default function Navbar() {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const { items } = useCart();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-2 cursor-pointer group">
            <div className="flex items-center gap-2">
              <span className="font-serif text-2xl font-bold text-primary">Bighorn</span>
              <span className="font-serif text-2xl font-bold text-primary">Family</span>
              <span className="font-serif text-2xl font-bold text-accent">Dental</span>
            </div>
          </Link>

          <div className="flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isActive('/') ? 'text-primary' : 'text-navy/70 hover:text-primary'
              }`}
            >
              Home
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isActive('/about') ? 'text-primary' : 'text-navy/70 hover:text-primary'
              }`}
            >
              About
            </Link>
            <Link
              to="/services"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isActive('/services') ? 'text-primary' : 'text-navy/70 hover:text-primary'
              }`}
            >
              Services
            </Link>
            <Link
              to="/pricing"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isActive('/pricing') ? 'text-primary' : 'text-navy/70 hover:text-primary'
              }`}
            >
              Pricing
            </Link>
            <a
              href="#contact"
              className="text-sm font-medium text-navy/70 hover:text-primary transition-colors cursor-pointer"
            >
              Contact
            </a>
          </div>

          <div className="flex items-center gap-4">
            <a
              href="tel:2296519254"
              className="flex items-center gap-2 text-sm font-medium text-navy/70 hover:text-primary transition-colors cursor-pointer"
            >
              <i className="ri-phone-line text-accent"></i>
              <span>(229) 651-9254</span>
            </a>
            <Link
              to="/checkout"
              className="relative cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-sand hover:bg-warm transition-all">
                <i className="ri-shopping-bag-2-line text-lg text-navy"></i>
              </div>
              {items.length > 0 && (
                <div className="absolute -top-1 -right-1 w-5 h-5 bg-accent rounded-full flex items-center justify-center text-white text-xs font-bold">
                  {items.length}
                </div>
              )}
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
